import { ICriterionService } from '../../../services/criterionService';
import bindAllMethods from '../../../utils/bindAllMethods';
import { getServices } from '../../../infra/startup';
import * as T from './types';

export class CriterionInterfaceV1 {
  private _criterionService: ICriterionService;

  constructor() {
    const services = getServices();
    this._criterionService = services.criterionService;
    bindAllMethods(this);
  }

  public getInterface(): T.CriterionInterfaceType<any> {
    const criterion = this._criterionService.getCriterionInstance();

    return {
      check: criterion.check,
      checkByCriterionKey: criterion.checkByCriterionKey,
      checkAdditionalCriterionDataByKey:
        criterion.checkAdditionalCriterionDataByKey,
      getCriterionByKey: criterion.getCriterionByKey,
      getCriterionList: criterion.getCriterionList,
      listen: criterion.listen,
      useReactCheck: criterion.useReactCheck,
      useReactCheckAdditionalCriterionData:
        criterion.useReactCheckAdditionalCriterionData,
      useReactCheckAdditionalCriterionDataByKey:
        criterion.useReactCheckAdditionalCriterionDataByKey,
      useReactCheckByCriterionKey: criterion.useReactCheckByCriterionKey
    };
  }
}
